var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lotteryComp"},[_c('TurnplateLottery',_vm._g(_vm._b({attrs:{"isShowAwardTitle":_vm.isShowAwardTitle},on:{"reportDraw":_vm.handleReportDraw}},'TurnplateLottery',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }